import style from "./Update.module.scss";
import React, { useState } from "react";
import { nervePostSchema } from "../../components/validation/Schema";
import { useDispatch } from "react-redux";
import { createCohort } from "../../redux/admin/actions/admin.actions";
import { agentAddedSuccessToast } from "../../components/NotificationToast";

const CreateForm = ({ setCreateModal, handleSuccessPost }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState(""); 

  const handleSubmit = async (e) => {
    e.preventDefault(); 

    try {
      setLoading(true);
       dispatch(createCohort({ name: name }));


      setName(""); 
      handleSuccessPost();
      agentAddedSuccessToast();
      setCreateModal(false);
      setLoading(false);
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h3 className="text-center" style={{color: "#b70303", fontWeight: "bold"}}>CREATE COHORT</h3>
      <div className="form-group">
        <label htmlFor="name">Name</label>
        <input
          type="text"
          className="form-control"
          id="name"
          name="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>

      <div className={style.buttonContainer}>
        <button
          type="submit"
          className={` shadow-none  ${style.actionBtn} ${style.reject}`}
          loading={loading}
        >
          Submit
        </button>
      </div>
    </form>
  );
};

export default CreateForm;
